import { ReactNode, useEffect, useState } from 'react';
import { cn } from 'utils/cn';

// Only the new design declares `--success-tint`, so classic falls back to the design's green.
const HIGHLIGHT_COLOR = 'var(--success-tint, rgba(76, 175, 80, 0.08))';

interface Props {
    /** Re-triggering the highlight requires remounting (change the element key). */
    active?: boolean;
    holdMs?: number;
    fadeMs?: number;
    className?: string;
    children: ReactNode;
}

/** Briefly tints newly added content green, then fades back to transparent. */
export function JustAddedHighlight({ active = true, holdMs = 2000, fadeMs = 800, className, children }: Props) {
    const [faded, setFaded] = useState(false);

    useEffect(() => {
        if (active) {
            const timer = setTimeout(() => setFaded(true), holdMs);
            return () => clearTimeout(timer);
        }
        return undefined;
    }, [active, holdMs]);

    const highlighted = active && !faded;

    return (
        <div
            className={cn('rounded-lg', className)}
            style={{
                backgroundColor: highlighted ? HIGHLIGHT_COLOR : 'transparent',
                transition: `background-color ${fadeMs}ms ease-out`,
            }}
        >
            {children}
        </div>
    );
}
